import React from 'react';
import floatIsland from 'assets/img/landdev/float_island.png';
import Background from 'components/common/Background';
import Flex from 'components/common/Flex';
import { Card } from 'react-bootstrap';
import dayjs from 'dayjs';

const GreetingCard = () => {
  const currentDate = dayjs(Date.now()).format('DD MMM YYYY');

  return (
    <Card
      className="bg-transparent-50 overflow-hidden"
      style={{
        backgroundColor: '#CBDEFF',
        marginBottom: '1rem'
      }}
    >
      <Card.Header className="position-relative">
        <Background
          image={floatIsland}
          className="d-none d-md-block bg-card z-1"
          style={{
            backgroundSize: '230px',
            backgroundPosition: 'right bottom',
            zIndex: '-1'
          }}
        />
        <div className="position-relative z-index-2">
          <div>
            <h3 className="text-primary mb-1">Good Day!</h3>
            <p className="text-700">
              Here’s what happening with your projects today - {currentDate}
            </p>
          </div>
          <Flex className="py-3">
            <div className="pe-3">
              <p className="text-600 fs-10 fw-medium">
                Total number of projects
              </p>
              <h4 className="text-800 mb-0">12</h4>
            </div>
            <div className="ps-3">
              <p className="text-600 fs-10">Total Investment</p>
              <h4 className="text-800 mb-0">$21,349.29</h4>
            </div>
          </Flex>
        </div>
      </Card.Header>
    </Card>
  );
};

export default GreetingCard;
